export default __webpack_public_path__ + "static/media/hht2_ep15_timeline_q03_a.c99d4cc3.png";